import { type MenuItem } from "primereact/menuitem";
import { type NavigateFunction } from "react-router-dom";

export function NavbarItems(navigate: NavigateFunction) {
    const items: MenuItem[] = [
        {
            label: 'Products',
            icon: 'pi pi-shopping-bag',
            items: [
                {
                    label: 'Sensor & Module',
                    items: [
                        { label: "Touch 1", command: () => navigate("/touch1") },
                        // { label: "IR 1" },
                        // { label: "Lux 1" },
                        { label: "Climate 1", command: () => navigate("/climate1") },
                        // { label: "PIR Motion 1" },
                        { label: "Ultra 1", command: () => navigate("/ultra1") },
                    ]
                },
                {
                    label: 'LED',
                    items: [
                        { label: "LED W1", command: () => navigate("/led-w1") },
                    ]
                },
                {
                    label: 'Power & Charging',
                    items: [
                        { label: "Charge C1", command: () => navigate("/charge-c1") },
                        { label: "Power C1", command: () => navigate("/power-c1") },
                        // { label: "Buck A1" },
                        // { label: "Boost A1" },
                        // { label: "Power A1" },
                    ]
                },
            // {
            //   label: 'Display',
            //   items: [
            //     { label: "D1602 1" },
            //   ]
            // },
            // {
            //   label: 'Interface & Adapter',
            //   items: [
            //     { label: "Serial T1" },
            //     { label: "Programmer STV2" },
            //     { label: "Interface 1" },
            //   ]
            // },
            // {
            //   label: 'Control & IO Board',
            //   items: [
            //     { label: "Relay A1" },
            //     { label: "Joystick A1" },
            //   ]
            // }
            ]
        },
        {
            label: 'Contact Us',
            icon: 'pi pi-envelope',
            command: () =>navigate("/contact-us")
        },
        {
            label: 'About Us',
            icon: 'pi pi-info-circle',
            command: () =>navigate("/about-us")
        }
    ];

    return items;
}